import { Button, DialogActions, DialogContent, Fab, Typography, makeStyles, useTheme } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { fetchHtml } from 'services/fetchUrl.service';
import { fmtColor } from 'util/format';
import { localizeCurrency } from 'util/localizeFormat';
import { useTrackEvent } from 'util/trackEvent';

const useStyles = makeStyles(theme => ({
  root: {
    padding: 0,
  },
  content: {
    minHeight: '80vh',
    [theme.breakpoints.down('sm')]: {
      minHeight: '90vh',
    }
  },
  dialogContent: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
    "&>img": {
      objectFit: "cover",
      width: 'inherit',
    }
  },
  topBar: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor: (props) => props.header_start_color
  },
  bottomBar: {
    bottom: 0,
    backgroundColor: theme.palette.background.paper,
  },
  button: {
    display: 'flex',
    flexDirection: 'column',
  },
  main: {
    fontWeight: 'bolder'
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    color: (props) => fmtColor(props.header_text_color),

  },
  preroot: {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    height: 150,
    color: (props) => fmtColor(props.header_text_color),
    '&>img': {
      height: 150 + theme.mixins.toolbar.minHeight,
      position: 'absolute',
      right: 0,
      bottom: 0,
    }
  }
}));
const CategoryContentDialog = ({ item,
  onClose = () => { },
  onSelect = (item) => { },
  isExtendedPackage = false,
  baseFee = 0,
  isSelected = false,
  onRemove = (item) => { },
}) => {
  const theme = useTheme()
  const styleProps = {
    header_start_color: fmtColor(item?.type?.color),
    header_end_color: fmtColor(item?.type?.color),
    header_text_color: theme.palette.secondary.contrastText,
  }
  const classes = useStyles(styleProps)
  const trackEvent = useTrackEvent()

  return (
    <>
      <DialogActions className={classes.topBar}>
        <div />
        <div className={classes.header}>
          <Typography variant="h4">
            {item?.type?.label}
          </Typography>
        </div>
        <Fab
          onClick={onClose}
          size="small"
          color="secondary"
          aria-label="close">
          <Close />
        </Fab>
      </DialogActions>
      
        <iframe
          className={classes.content}
          src={item?.type?.overlay_html_url}
        />
      <DialogActions
        className={classes.bottomBar}
      >
        <Button
          onClick={() => {
            trackEvent('Create Booking Service Package - Category Item', { item: item?.type?.label, id: item?.id })
            onSelect(item)
          }}
          variant="contained"
          color="primary"
          fullWidth
          classes={{
            label: classes.button,
          }}
        ><Typography variant="button" className={classes.main}>
            Select
          </Typography>
        </Button>
      </DialogActions>
    </>
  )
}

export { CategoryContentDialog }